"use client";
import { useState } from "react";
import Image from "next/image";

export default function ArticleHero({ src, alt }) {
  const [error, setError] = useState(false);

  return (
    <div className="relative w-full aspect-[16/7] rounded-2xl overflow-hidden bg-gray-200 mb-7">
      {src && !error && (
        <Image
          fill
          src={src}
          alt={alt || "Blog post"}
          className="object-cover"
          onError={() => setError(true)}
          sizes="(max-width: 1024px) 100vw, 760px"
          priority
        />
      )}
    </div>
  );
}
